import { render, staticRenderFns } from "./ZncLogin.vue?vue&type=template&id=0297f3d8&"
import script from "./ZncLogin.vue?vue&type=script&lang=js&"
export * from "./ZncLogin.vue?vue&type=script&lang=js&"
import style0 from "./ZncLogin.vue?vue&type=style&index=0&id=0297f3d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports